const Flickity = require('flickity');
const smoothScroll = require('smooth-scroll');
const opinionSlider = document.querySelector('.js-opinion_slider');

/* eslint-disable no-new */
new Flickity(opinionSlider, {
  pageDots: true,
  freeScroll: false,
  wrapAround: true,
  cellAlign: 'center',
  prevNextButtons: false,
});


smoothScroll.init({
  selector: '[data-scroll]',
  speed: 700,
  easing: 'easeOutQuint',
  offset: 0,
  updateURL: true,
});



/** WEBPACK FOOTER **
 ** ./src/application.js
 **/